import { AuthenticationProvider } from './common/services/AuthenticationService';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SettingsProvider } from './common/services/SettingsService';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ChakraProvider, CSSReset } from '@chakra-ui/react';
import theme from './common/customTheme/theme';
import { createRoot } from 'react-dom/client';
import '@total-typescript/ts-reset';
import Routes from './Routes';
import React from 'react';
import App from './App';

const queryClient = new QueryClient();
const root = createRoot(document.getElementById('root')!);

function render() {
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ChakraProvider theme={theme}>
          <CSSReset />
          <AuthenticationProvider>
            <SettingsProvider>
              <App>
                <Routes />
              </App>
            </SettingsProvider>
          </AuthenticationProvider>
        </ChakraProvider>
        <ReactQueryDevtools initialIsOpen={import.meta.env.DEV} />
      </QueryClientProvider>
    </React.StrictMode>,
  );
}

render();
